"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  hero: {
    fontFamily: 'inherit',
    fontSize: '3.5rem',
    lineHeight: 1.178
  },
  h1: {
    fontFamily: 'inherit',
    fontWeight: 700,
    fontSize: '1.875rem',
    lineHeight: 1.266,
    letterSpacing: '-0.01562em'
  },
  h2: {
    fontFamily: 'inherit',
    fontWeight: 700,
    fontSize: '1.375rem',
    lineHeight: 1.181,
    letterSpacing: '-0.00833em'
  },
  h3: {
    fontFamily: 'inherit',
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1.3,
    letterSpacing: '0em'
  },
  h4: {
    fontFamily: 'inherit',
    fontWeight: 400,
    fontSize: '1.25rem',
    lineHeight: 1.3,
    letterSpacing: '0.00735em'
  },
  h5: {
    fontFamily: 'inherit',
    fontWeight: 400,
    fontSize: '1.125rem',
    lineHeight: 1.333,
    letterSpacing: '0em'
  },
  h6: {
    fontFamily: 'inherit',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.375,
    letterSpacing: '0.0075em'
  },
  subheading: {
    fontFamily: 'inherit',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.375
  },
  body: {
    fontFamily: 'inherit',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.375
  },
  button: {
    fontFamily: 'inherit',
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: 1.333,
    textTransform: 'none'
  },
  buttonLink: {
    fontFamily: 'inherit',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.375
  },
  supportText: {
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.428
  },
  smallText: {
    fontFamily: 'inherit',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.25
  },
  smallTextBold: {
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: 1.428
  },
  strikeText: {
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: 1.428
  }
};